import { render, staticRenderFns } from "./Assesment.vue?vue&type=template&id=2b027d0c&scoped=true&"
import script from "./Assesment.vue?vue&type=script&lang=js&"
export * from "./Assesment.vue?vue&type=script&lang=js&"
import style0 from "./Assesment.vue?vue&type=style&index=0&id=2b027d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b027d0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
